/* @flow */

import type { LocationShape } from "react-router-dom";

import React from "react";
import { Link } from "react-router-dom";
import { Button as ButtonComponent } from "@crossroads/ui-components";

type Props = {
  children: React$Node,
  to?: string | LocationShape,
};

const Button = ({ to, children, ...props }: Props): React$Node => {
  if (to) {
    if (typeof to === "string" && to.slice(0, 4) === "http") {
      return (
        <ButtonComponent
          {...props}
          href={to}
          elem="a"
        >
          {children}
        </ButtonComponent>
      );
    }

    return (
      <ButtonComponent
        {...props}
        elem={Link}
        to={to}
      >
        {children}
      </ButtonComponent>
    );
  }

  return <ButtonComponent {...props}>{children}</ButtonComponent>;
};

export default Button;
